import { PriceRecommendationKpi } from '@/features/priceReco/PriceRecommendationKpi'
import { BlacklistWidget } from '@/features/proxies/BlacklistWidget'
import { SiteUsageWidget } from '@/features/proxies/SiteUsageWidget'
import { NextScreeningWidget } from '@/features/ratescreener/NextScreeningWidget'
import { RateScreenerIssuesWidget } from '@/features/ratescreener/RateScreenerIssuesWidget'
import { RateScreenerKpi } from '@/features/ratescreener/RateScreenerKpi'
import { SitesWidget } from '@/features/ratescreener/SitesWidget'
import { SchedulersWidget } from '@/features/scheduler/SchedulersWidget'
import { SentinelKpi } from '@/features/sentinel/SentinelKpi'
import { SentinelSitesWidget } from '@/features/sentinel/SentinelSitesWidget'
import { TokenWidget } from '@/features/team/TokenWidget'
import styles from './CockpitPage.module.css'

/** The dashboard: every widget owns its data; the grid only places them. */
export function CockpitPage() {
  return (
    <div className={styles.grid}>
      <RateScreenerKpi className={styles.rskpi} />
      <SentinelKpi className={styles.sentinelkpi} />
      <PriceRecommendationKpi className={styles.pricekpi} />
      <TokenWidget className={styles.token} />
      <RateScreenerIssuesWidget className={styles.issues} />
      <SchedulersWidget className={styles.schedulers} />
      <SitesWidget className={styles.sites} />
      <SiteUsageWidget className={styles.usage} />
      <NextScreeningWidget className={styles.next} />
      <SentinelSitesWidget className={styles.sentinelsites} />
      <BlacklistWidget className={styles.blacklist} />
    </div>
  )
}
